<template>
    <base-modal
    :ref="modal.key"
    :show="showMergeDocumentModal"
    @on-confirm="mergeDocuments()"
    :okText="$t('Merge')"
    @on-cancel="hideModal()"
    :showCancelButton="true"
    :title="modalTitle"
  >
    <v-card-text style="line-height: 1.5;" class="pb-0 ps-1">{{ mergeDocumentsMessage }}</v-card-text>
    <v-radio-group v-model="mergeAtStart">
        <v-radio
            :value="true"
            v-bind:label="$t('MergeAtDocumentStart').replace('{1}', getFileNameWithoutExtension(documentToMergeWith.originalFileName))"
        ></v-radio>
        <v-radio
            v-bind:label="$t('MergeAtDocumentEnd').replace('{1}', getFileNameWithoutExtension(documentToMergeWith.originalFileName))"
            :value="false"
        ></v-radio>
    </v-radio-group>
  </base-modal>
</template>
<script>
import Utils from '@/ecm/common/Utils';
import DocumentIntelligenceProvidersService from '@/services/DocumentIntelligenceProvidersService';
export default {
    name: 'MergePendingRecognitionDocumentModal',
    data() {
        return {
            showMergeDocumentModal: false,
            modal: {
                title: `${this.$t('MergeDocuments')}`,
                key: 'mergeDocumentsModal',
            },
            documentToBeMerged: {},
            documentToMergeWith: {},
            mergeAtStart: false
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return this.modal.title;
        },
        mergeDocumentsMessage() {
            return this.$t('MergeDocumentsMessage')
                .replace('{0}', this.getFileNameWithoutExtension(this.documentToBeMerged.originalFileName))
                .replace('{1}', this.getFileNameWithoutExtension(this.documentToMergeWith.originalFileName));
        }
    },
    methods: {
        show(documentToBeMerged, documentToMergeWith) {
            this.showMergeDocumentModal = true;
            this.documentToBeMerged = documentToBeMerged;
            this.documentToMergeWith = documentToMergeWith;
        },
        getFileNameWithoutExtension(fileName) {
            if (!fileName) return;
            return fileName.split('.').slice(0, -1).join('.');
        },
        hideModal() {
            this.showMergeDocumentModal = false;
        },
        mergeDocuments() {
            this.modalInstance.progress(true);

            const request = {
                DocumentToBeMergedId: this.documentToBeMerged.messageId,
                DocumentToMergeWithId: this.documentToMergeWith.messageId,
                MergeAtStart: this.mergeAtStart
            };
            DocumentIntelligenceProvidersService.mergeDocuments(request).then(() => {
                Utils.toast.success(this.$t('DocumentsMergedSuccessfully'));
                this.$emit('on-merge-documents', this.documentToMergeWith);
                this.hideModal();
            }).catch(() => {
            }).then(() => {
                this.modalInstance.progress(false);
            });
        }
    }
};
</script>